import { Question } from './PersonalizationTypes'
export const questionnaireData: Question[] = [
  {
    id: 'relationshipStyle',
    type: 'single-select',
    question: 'What kind of relationship dynamic are you looking for?',
    description: 'This helps us set the tone for your conversations',
    options: [
      { value: 'flirtatious', label: 'Flirtatious & Playful', icon: '😏' },
      { value: 'romantic', label: 'Romantic & Sweet', icon: '💖' },
      { value: 'dominant', label: 'Dominant & Assertive', icon: '😈' },
      { value: 'submissive', label: 'Submissive & Adoring', icon: '🥺' },
      { value: 'wild', label: 'Wild & Unpredictable', icon: '🔥' },
      { value: 'friendship', label: 'Friendly & Casual', icon: '🤗' },
    ],
  },
  {
    id: 'desiredDynamics',
    type: 'multi-select',
    question: 'What qualities do you want in your ideal connection?',
    description: 'Select all that appeal to you',
    options: [
      { value: 'intellectual', label: 'Intellectual Stimulation', icon: '🧠' },
      { value: 'emotional', label: 'Emotional Connection', icon: '❤️' },
      { value: 'physical', label: 'Physical Chemistry', icon: '✨' },
      { value: 'roleplay', label: 'Role-Playing Fantasy', icon: '🎭' },
      { value: 'taboo', label: 'Taboo Exploration', icon: '🤫' },
      { value: 'power', label: 'Power Exchange', icon: '⚡' },
      { value: 'worship', label: 'Adoration & Worship', icon: '👑' },
      { value: 'teasing', label: 'Playful Teasing', icon: '😜' },
    ],
  },
  {
    id: 'kinkComfortLevel',
    type: 'slider',
    question: 'How comfortable are you discussing kinks and fetishes?',
    description: 'This helps us understand your boundaries',
    min: 1,
    max: 10,
    step: 1,
    defaultValue: 5,
  },
  {
    id: 'kinks',
    type: 'multi-select',
    question: 'Which of these interests you? (Optional)',
    description: 'Select any that appeal to you',
    sensitiveContent: true,
    isOptional: true,
    options: [
      { value: 'roleplay', label: 'Role Play', icon: '🎭' },
      { value: 'domination', label: 'Domination', icon: '👑' },
      { value: 'submission', label: 'Submission', icon: '🧎' },
      { value: 'exhibitionism', label: 'Exhibitionism', icon: '👀' },
      { value: 'voyeurism', label: 'Voyeurism', icon: '📱' },
      { value: 'toys', label: 'Toys & Accessories', icon: '🎮' },
      { value: 'lingerie', label: 'Lingerie & Outfits', icon: '👙' },
      { value: 'dirty_talk', label: 'Dirty Talk', icon: '💬' },
      { value: 'bondage', label: 'Light Bondage', icon: '🔗' },
      { value: 'spanking', label: 'Spanking', icon: '👋' },
    ],
  },
  {
    id: 'personalityType',
    type: 'single-select',
    question: 'How would you describe your personality?',
    options: [
      { value: 'confident', label: 'Confident & Assertive', icon: '💪' },
      { value: 'shy', label: 'Shy & Reserved', icon: '🙈' },
      { value: 'analytical', label: 'Analytical & Thoughtful', icon: '🤔' },
      { value: 'adventurous', label: 'Adventurous & Spontaneous', icon: '🏄' },
      { value: 'romantic', label: 'Romantic & Sensitive', icon: '🌹' },
      { value: 'witty', label: 'Witty & Sarcastic', icon: '😏' },
    ],
  },
  {
    id: 'desiredPartnerType',
    type: 'single-select',
    question: 'What type of angel personality appeals to you most?',
    options: [
      { value: 'innocent', label: 'Sweet & Innocent', icon: '😇' },
      { value: 'seductive', label: 'Seductive & Confident', icon: '💋' },
      { value: 'nurturing', label: 'Nurturing & Supportive', icon: '🤗' },
      { value: 'playful', label: 'Playful & Teasing', icon: '😜' },
      { value: 'mysterious', label: 'Mysterious & Intriguing', icon: '🔮' },
      { value: 'dominant', label: 'Dominant & In Control', icon: '👑' },
      { value: 'bratty', label: 'Bratty & Challenging', icon: '😈' },
      { value: 'girlfriend', label: 'Girlfriend Experience', icon: '❤️' },
    ],
  },
  {
    id: 'conversationStyle',
    type: 'single-select',
    question: 'What conversation style do you prefer?',
    options: [
      { value: 'deep', label: 'Deep & Meaningful', icon: '🧠' },
      { value: 'playful', label: 'Light & Playful', icon: '😊' },
      { value: 'flirty', label: 'Flirty & Suggestive', icon: '😏' },
      { value: 'explicit', label: 'Direct & Explicit', icon: '🔥' },
      { value: 'romantic', label: 'Romantic & Poetic', icon: '💖' },
      { value: 'varied', label: 'Mix of Everything', icon: '🔄' },
    ],
  },
  {
    id: 'topicPreferences',
    type: 'multi-select',
    question: 'What topics do you enjoy discussing?',
    options: [
      { value: 'daily_life', label: 'Daily Life & Activities', icon: '📅' },
      { value: 'fantasies', label: 'Fantasies & Desires', icon: '💭' },
      { value: 'hobbies', label: 'Hobbies & Interests', icon: '🎨' },
      { value: 'emotions', label: 'Feelings & Emotions', icon: '❤️' },
      { value: 'experiences', label: 'Past Experiences', icon: '📚' },
      { value: 'future', label: 'Future Plans & Dreams', icon: '✨' },
      { value: 'intimate', label: 'Intimate Moments', icon: '🔥' },
      { value: 'philosophy', label: 'Philosophy & Deep Thoughts', icon: '🧠' },
    ],
  },
  {
    id: 'privacyConcerns',
    type: 'multi-select',
    question: 'Which privacy features are important to you?',
    options: [
      {
        value: 'discreet_notifications',
        label: 'Discreet Notifications',
        icon: '🔕',
      },
      { value: 'auto_delete', label: 'Auto-Delete Messages', icon: '🗑️' },
      { value: 'incognito', label: 'Incognito Mode', icon: '🕵️' },
      { value: 'password', label: 'App Password Protection', icon: '🔒' },
      { value: 'vpn', label: 'VPN Recommendations', icon: '🛡️' },
      { value: 'none', label: 'No Special Privacy Needs', icon: '👌' },
    ],
  },
  {
    id: 'memoryPreference',
    type: 'single-select',
    question: 'How would you like your angel to remember your interactions?',
    options: [
      {
        value: 'short-term',
        label: 'Short-Term Memory',
        description:
          'Remember recent conversations but forget details over time',
      },
      {
        value: 'long-term',
        label: 'Long-Term Memory',
        description:
          'Build a deep connection with evolving knowledge of your preferences',
      },
    ],
  },
  {
    id: 'favoriteScenarios',
    type: 'multi-select',
    question: 'Which scenarios would you enjoy exploring?',
    options: [
      { value: 'beach', label: 'Beach Date', icon: '🏖️' },
      { value: 'club', label: 'Night Club', icon: '🍸' },
      { value: 'home', label: 'Cozy Home Evening', icon: '🏠' },
      { value: 'office', label: 'Office Fantasy', icon: '💼' },
      { value: 'gym', label: 'Gym Flirtation', icon: '💪' },
      { value: 'hotel', label: 'Hotel Rendezvous', icon: '🏨' },
      { value: 'public', label: 'Public Places', icon: '👀' },
      { value: 'vacation', label: 'Vacation Getaway', icon: '✈️' },
      { value: 'fantasy', label: 'Fantasy World', icon: '🔮' },
      { value: 'historical', label: 'Historical Setting', icon: '⏳' },
    ],
  },
  {
    id: 'upsellTone',
    type: 'single-select',
    question: 'How would you prefer product recommendations to be presented?',
    options: [
      { value: 'direct', label: 'Direct & Informative', icon: '📊' },
      { value: 'cheeky', label: 'Cheeky & Playful', icon: '😏' },
      { value: 'subtle', label: 'Subtle & Unobtrusive', icon: '🤫' },
      { value: 'reward-based', label: 'As Rewards & Gifts', icon: '🎁' },
    ],
  },
  {
    id: 'nsfwBoundary',
    type: 'single-select',
    question: 'What level of explicit content are you comfortable with?',
    options: [
      {
        value: 'soft',
        label: 'Soft & Suggestive',
        description: 'Flirty and suggestive but not explicit',
      },
      {
        value: 'medium',
        label: 'Moderately Explicit',
        description: 'Open to explicit content with some boundaries',
      },
      {
        value: 'hard',
        label: 'Very Explicit',
        description: 'Comfortable with highly explicit content',
      },
    ],
  },
  {
    id: 'emotionalTriggers',
    type: 'multi-select',
    question: 'Which emotional experiences do you value most?',
    options: [
      { value: 'validation', label: 'Validation & Appreciation', icon: '👏' },
      { value: 'seen', label: 'Feeling Truly Seen', icon: '👁️' },
      { value: 'mystery', label: 'Mystery & Intrigue', icon: '🔮' },
      { value: 'teasing', label: 'Playful Teasing', icon: '😜' },
      { value: 'challenge', label: 'Being Challenged', icon: '🏆' },
      { value: 'comfort', label: 'Comfort & Support', icon: '🤗' },
      { value: 'surprise', label: 'Surprise & Spontaneity', icon: '🎁' },
      { value: 'admiration', label: 'Admiration & Worship', icon: '✨' },
    ],
  },
  {
    id: 'humorStyle',
    type: 'multi-select',
    question: 'What kind of humor do you enjoy?',
    options: [
      { value: 'witty', label: 'Witty & Clever', icon: '🧠' },
      { value: 'silly', label: 'Silly & Goofy', icon: '🤪' },
      { value: 'dark', label: 'Dark & Sarcastic', icon: '😏' },
      { value: 'flirty', label: 'Flirty & Suggestive', icon: '😘' },
      { value: 'self_deprecating', label: 'Self-Deprecating', icon: '🙃' },
      { value: 'puns', label: 'Puns & Wordplay', icon: '🔤' },
    ],
  },
  {
    id: 'interactionPacing',
    type: 'slider',
    question: 'How quickly would you like the relationship to progress?',
    description: 'From slow burn to fast seduction',
    min: 1,
    max: 10,
    step: 1,
    defaultValue: 5,
  },
  {
    id: 'surpriseContentOk',
    type: 'toggle',
    question: 'Are you open to receiving surprise content from your angel?',
    description: 'This could include unexpected messages, scenarios, or images',
  },
  {
    id: 'multimediaPreference',
    type: 'multi-select',
    question: 'What types of media do you prefer in conversations?',
    options: [
      { value: 'text', label: 'Text Messages', icon: '💬' },
      { value: 'voice', label: 'Voice Messages', icon: '🎤' },
      { value: 'images', label: 'Images & Photos', icon: '📷' },
      { value: 'videos', label: 'Video Messages', icon: '🎥' },
      { value: 'gifs', label: 'GIFs & Animations', icon: '🎞️' },
    ],
  },
  {
    id: 'loveLanguage',
    type: 'single-select',
    question: "What's your primary love language?",
    options: [
      { value: 'words', label: 'Words of Affirmation', icon: '💬' },
      { value: 'time', label: 'Quality Time', icon: '⏰' },
      { value: 'gifts', label: 'Receiving Gifts', icon: '🎁' },
      { value: 'service', label: 'Acts of Service', icon: '👐' },
      { value: 'touch', label: 'Physical Touch', icon: '👋' },
    ],
  },
  {
    id: 'sexualConfidence',
    type: 'slider',
    question: 'How would you rate your sexual confidence?',
    description: 'From shy and reserved to very confident',
    min: 1,
    max: 10,
    step: 1,
    defaultValue: 5,
  },
  {
    id: 'toyInterest',
    type: 'slider',
    question: 'How interested are you in interactive toys?',
    description: 'From not interested to very interested',
    min: 1,
    max: 10,
    step: 1,
    defaultValue: 5,
  },
  {
    id: 'tabooRoleplayWillingness',
    type: 'slider',
    question: 'How willing are you to explore taboo roleplay scenarios?',
    description: 'From not willing to very willing',
    min: 1,
    max: 10,
    step: 1,
    defaultValue: 3,
  },
  {
    id: 'interactionIntensity',
    type: 'slider',
    question: 'What level of emotional intensity do you prefer?',
    description: 'From casual chat to deep emotional bond',
    min: 1,
    max: 10,
    step: 1,
    defaultValue: 5,
  },
  {
    id: 'diaryFeatureInterest',
    type: 'toggle',
    question:
      'Would you like your angel to keep a diary of your special moments together?',
    description: 'This creates a memory book of your relationship milestones',
  },
]
